export default __webpack_public_path__ + "static/media/proto.4c81f00e.png";